import { render, staticRenderFns } from "./BCardCode1.vue?vue&type=template&id=3230ba2b&scoped=true"
import script from "./BCardCode1.vue?vue&type=script&lang=js"
export * from "./BCardCode1.vue?vue&type=script&lang=js"
import style0 from "./BCardCode1.vue?vue&type=style&index=0&id=3230ba2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230ba2b",
  null
  
)

export default component.exports